import { render } from "./TheDataset.vue?vue&type=template&id=04529344"
import script from "./TheDataset.vue?vue&type=script&lang=js"
export * from "./TheDataset.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__